import { useRouteKey, type UseRoute } from '@/injectionKeys';

export const useNuxtRoute = () => {
  const injectedUseRoute = inject(useRouteKey) as UseRoute;
  const route = injectedUseRoute();
  return route;
};
